import React from 'react';
import PropTypes from 'prop-types';

import MobileHeader from "./components/MobileHeader";
import FiltersRow from "./components/FiltersRow";
import OrderCardsList from "./components/OrderCardsList";

MobileView.propTypes = {
    search: PropTypes.string,
    setSearch: PropTypes.func
};

function MobileView({search, setSearch}) {
    return (
        <div style={{backgroundColor: 'white'}}>
            <MobileHeader search={search} setSearch={setSearch} />
            <FiltersRow />
            <OrderCardsList />
        </div>
    );
}

export default MobileView;
